<template>
  <Modal :show.sync="show">
    <div class="row">
      <div class="col-12">
        <ul class="nav nav-tabs nav-line-tabs nav-line-tabs-2x mb-1 fs-6">
          <li class="nav-item">
            <a class="nav-link active fw-semibold text-dark" data-bs-toggle="tab" href="#contact_support_tab">
              {{ $t('contact-support') }}
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link fw-semibold text-dark" data-bs-toggle="tab" href="#help_center_tab">
              {{ $t('help-center') }}
            </a>
          </li>
        </ul>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div id="myTabContent" class="tab-content">
          <div id="contact_support_tab" class="tab-pane fade show active" role="tabpanel">
            <div class="fs-6 fw-semibold m-3">
              {{ $t('please-provide-us-with-your-basic-details-below-and-our-team-will-reach-out-to-you') }}
            </div>
            <div>
              <div class="row mb-3">
                <div class="col d-flex justify-content-between">
                  <input
                    v-model="formData.name"
                    data-test="contact_name"
                    type="text"
                    class="form-control"
                    :placeholder="$t('network.name')"
                    required
                  />
                  <sup class="text-danger ms-1 mt-4 fs-5">*</sup>
                </div>
                <div class="col d-flex justify-content-between">
                  <input
                    v-model="formData.email"
                    data-test="contact_email"
                    type="email"
                    class="form-control"
                    :placeholder="$t('network.auth.email')"
                    required
                  />
                  <sup class="text-danger ms-1 mt-4 fs-5">*</sup>
                </div>
              </div>
              <div class="row mb-4">
                <div class="col d-flex justify-content-between">
                  <textarea
                    v-model="formData.message"
                    data-test="contact_message"
                    class="form-control"
                    rows="5"
                    :placeholder="$t('enter-your-message')"
                    required
                  ></textarea>
                  <sup class="text-danger ms-1 mt-4 fs-5">*</sup>
                </div>
              </div>
              <div class="row mb-2">
                <div class="col">
                  <button
                    class="btn btn-primary"
                    :disabled="isSaving"
                    data-test="btn_contact_submit"
                    @click="submitContactSupport"
                  >
                    <i class="fa-regular fa-paper-plane"></i>
                    {{ $t('send') }}
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div id="help_center_tab" class="tab-pane fade" role="tabpanel">
            <div class="fs-6 fw-semibold m-3 mb-0">
              {{ $t('find-answers-to-commonly-asked-questions-and-access-resources-to-unlock-the-full-potential-of-networks') }}
            </div>
            <div class="row">
              <div class="col-12">
                <div v-for="article in articles" :key="article.title">
                  <div class="d-flex mt-3" style="justify-content: space-between; align-items: center; font-size: medium;">
                    <span class="fw-semibold me-2">{{ article.title }}</span>
                    <div class="justify-content-end">
                      <a :href="article.url" target="_blank" class="me-1 fw-bold">{{ $t('read') }}</a>
                    </div>
                  </div>
                  <div class="separator"></div>
                </div><br>
                <div class="fs-6 fw-semibold mb-2">
                  {{ $t('unable-to-find-what-youre-looking-for') }}
                  <a :href="viewAllArticles" target="_blank" class="fw-bold">{{ $t('view-all-articles') }}</a>
                </div>
              </div>
            </div>
            <hr style="background: repeating-linear-gradient(239deg, transparent, transparent 10px, black 10px, black 20px);margin: 20px 0px;" />
            <div class="fs-6 fw-semibold m-3 mb-0">
              Access our training network to explore relevant videos on using our product suite.
            </div>
            <div class="row">
              <div class="col-12">
                <div class="d-flex mt-3" style="justify-content: space-between; align-items: center; font-size: medium;">
                  <span class="fw-semibold me-2">
                    Resonance Training Network
                  </span>
                  <div class="justify-content-end">
                    <a href="/networks/resonance-training" target="_blank" class="me-1 fw-bold">Access</a>
                  </div>
                </div>
                <div class="separator"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <template #footer>
      <button id="close" data-test="close" class="btn btn-bg-light btn-sm me-2" @click="closeModal">
        {{ $t('Nav.close') }}
      </button>
    </template>
  </Modal>
</template>
<script>
import Modal from '@/components/commons/Modals/Modal.vue';

export default {
  name: 'HelpAndSupport',
  components: {
    Modal
  },
  props: {
    isShowModal: {
      type: Number,
      required: true
    },
  },
  data() {
    return {
      show: false,
      freescoutApiKey: process.env.VUE_APP_FREESCOUT_API_KEY,
      articles: [
        {
          title: this.$t('how-to-find-and-join-a-network'),
          url: 'https://support.resonancehealth.net/hc/4204616749/15/how-to-find-and-join-a-network?category_id=13',
        },
        {
          title: this.$t('how-to-search-for-media'),
          url: 'https://support.resonancehealth.net/hc/4204616749/14/how-to-search-for-media?category_id=13',
        },
        {
          title: this.$t('how-to-join-a-networks-meeting'),
          url: 'https://support.resonancehealth.net/hc/4204616749/16/how-to-join-a-network-meeting?category_id=11',
        },
        {
          title: this.$t('how-to-add-networks-meetings-to-your-calendar'),
          url: 'https://support.resonancehealth.net/hc/4204616749/17/how-to-add-network-meetings-to-your-calendar?category_id=11',
        },
      ],
      viewAllArticles: 'https://support.resonancehealth.net/hc/4204616749',
      formData: {
        name: null,
        email: null,
        message: null,
      },
      isSaving: false,
    };
  },
  computed: {
    authUser() {
      return this.$store.getters['user'];
    },
    authenticated() {
      return this.$store.getters.auth;
    },
  },
  watch: {
    isShowModal() {
      this.show = true;
    }
  },
  mounted() {
    if (this.authenticated) {
      this.formData.email = this.authUser.email;
      this.formData.name = this.authUser.first_name + ' ' + this.authUser.last_name;
    }
  },
  methods: {
    submitContactSupport() {
      // validate that the email is an actual email by using regex
      const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
      if (!emailRegex.test(this.formData.email)) {
        this.$swal.fire({
          icon: 'error',
          title: this.$t('please-enter-a-valid-email-address'),
        });
        return;
      }
      // validate that both name and message are not empty
      if (!this.formData.name || !this.formData.message) {
        this.$swal.fire({
          icon: 'error',
          title: this.$t('please-fill-in-all-required-fields'),
        });
        return;
      }

      const body = {
        type: 'email',
        mailboxId: 2, // in prod use 2
        subject: 'Message from Networks Contact Form',
        customer: {
          email: this.formData.email,
          firstName: this.formData.name,
        },
        threads: [
          {
            text: this.formData.message,
            type: 'customer',
            customer: {
              email: this.formData.email,
              firstName: this.formData.name,
            },
          },
        ],
        imported: false,
        status: 'active',
      };

      if (process.env.VUE_APP_ENV != 'local') {
        this.postData('https://support.resonancehealth.net/api/conversations', body);
      } else {
        alert('Sending the contact us form is disabled in the local environment.');
      }
    },
    clearFormData() {
      this.formData.name = null;
      this.formData.email = null;
      this.formData.message = null;
      this.isSaving = false;
    },
    async postData(url = '', body = {}) {
      this.isSaving = true;
      try {
        const response = await this.$http.post(url, body, {
          headers: {
            'X-FreeScout-API-Key': this.freescoutApiKey,
            'Content-Type': 'application/json',
            Accept: 'application/hal+json',
          },
        });

        if (response.status >= 200 && response.status < 300) {
          this.$swal.fire({
            icon: 'success',
            title: this.$t('thank-you-for-contacting-us'),
            text: this.$t('your-message-has-been-successfully-submitted-we-ll-get-back-to-you-as-soon-as-possible'),
          });
        } else {
          this.$swal.fire({
            icon: 'error',
            title: 'Oops!',
            text: this.$t('something-went-wrong-while-submitting-your-message-please-try-again-later'),
          });
        }
        this.clearFormData();
        this.closeModal();
      } catch (err) {
        console.log('err: ', err);

        // check for network error
        if (!err.response) {
          // network error (e.g., user is offline)
          this.$swal.fire({
            icon: 'error',
            title: 'Network Error',
            text: 'Looks like you are offline. Please try again after reestablishing your internet connection.',
          });
        } else {
          this.$swal.fire({
            icon: 'error',
            title: 'Oops!',
            text: this.$t('there-was-an-error-submitting-your-message-please-try-again-later'),
          });
        }
        this.clearFormData();
        this.closeModal();
      } finally {
        this.isSaving = false;
      }
    },
    closeModal() {
      this.show = false;
    },
  }
};
</script>
<style scoped>
.nav-line-tabs.nav-line-tabs-2x {
  border-bottom-width: 2px;
}
.nav-line-tabs {
  border-bottom-width: 1px;
  border-bottom-style: solid;
  border-bottom-color: #eff2f5;
}
.nav-line-tabs.nav-line-tabs-2x .nav-item {
  margin-bottom: -2px;
}
.nav-line-tabs .nav-item {
  margin-bottom: -1px;
}
.nav-line-tabs.nav-line-tabs-2x .nav-item .nav-link.active, .nav-line-tabs.nav-line-tabs-2x .nav-item.show
.nav-link, .nav-line-tabs.nav-line-tabs-2x .nav-item .nav-link:hover:not(.disabled) {
  border-bottom-width: 2px;
}
html a:hover, html a:active, html a:focus, body a:hover, body a:active, body a:focus {
  text-decoration: none !important;
}
.nav-line-tabs .nav-item .nav-link.active, .nav-line-tabs .nav-item.show
.nav-link, .nav-line-tabs .nav-item .nav-link:hover:not(.disabled) {
  background-color: transparent;
  border: 0;
  border-bottom: 1px solid #005f9a;
  transition: color .2s ease, background-color .2s ease;
  text-decoration: none !important;
}
.nav-line-tabs .nav-item .nav-link {
  color: #a1a5b7;
  border: 0;
  border-bottom: 1px solid transparent;
  border-radius: inherit;
  transition: color .2s ease, background-color .2s ease;
  padding: 0.5rem 0;
  margin: 0 1rem;
}
.nav-link:hover, .nav-link:focus {
  color: #00304e;
  text-decoration: none;
}
.separator {
  border-bottom-style: dashed;
  border-bottom-color: #dfdfdf;
  display: block;
  height: 0;
  border-bottom: 1px solid #dfdfdf;
}
</style>
